import React, { useState, useEffect } from 'react';
import {sendStatistics} from "../../../../services/dataColectorService";
import {useAppContext} from "../../../../AppDataContext";
import {logDebug} from "../../../../utils/logger";

interface CustomLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {wrappedParams?: any; }


const CustomLink: React.FC<CustomLinkProps> = ({ href, children,wrappedParams, ...props }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [isMouseDown, setIsMouseDown] = useState(false);
const appDataContent = useAppContext() // Use the context hook to get the context value
  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const handleMouseDown = () => {
    //alert(wrappedParams); // Use wrappedParams here
    // @ts-ignore
    if(upgradeToPro()){
        (async () =>
           sendStatistics(
          wrappedParams.proxy,
          wrappedParams.client_id,
          wrappedParams.user_id,
          wrappedParams.client_token,
          {'CLICK_ON_PRO_LINK':1}, false))();
    }
     setIsMouseDown(true);
  };

// Handles the mouse up event by resetting the mouse down state
const handleMouseUp = () => {
    setIsMouseDown(false);
};

// Handles the click event for the link
const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  if (upgradeToPro() &&
      appDataContent.client_id === "SKILLING" && appDataContent.userClass === "demo") {
      logDebug("sending message to parent");
    window.parent.postMessage({type: "hyperlinkToPro"}, "*");
    e.preventDefault(); // Prevent the hyperlink from being opened
  }
};

// Determines if the link should trigger an upgrade to pro
function upgradeToPro() {
  return (typeof children === 'string' && (children.includes("\u200B\u200B\u200B") ||
      children === "UPGRADE TO PRO"))
}

// Determines if the link should open in a new tab
function openLinkInNewTab() {
  return (
      ((appDataContent.client_id === "SKILLING" && appDataContent.userClass === "demo") && !upgradeToPro()) ||
      (!(appDataContent.client_id === "SKILLING" && appDataContent.userClass === "demo"))
  );
}
  useEffect(() => {

    if (isHovering && isMouseDown && href) {
       if (openLinkInNewTab()) {
          window.open(href, '_blank', 'noopener,noreferrer');
       }
      setIsMouseDown(false); // Reset state after opening the link
    }
  }, [isHovering, isMouseDown, href]);

  return (
    <a
      href={href}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onClick={handleClick} // Add the onClick handler
      {...props}
    >
      {children}
    </a>
  );
};

export default CustomLink;
